export default __webpack_public_path__ + "static/media/vusdt.326a3d1c.png";